// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "78b3b254b2bc";
export const BUILD_VERSION_NUMBER = 13;
